import { render, staticRenderFns } from "./DocumentDriverLicense.vue?vue&type=template&id=7b51baac&scoped=true"
var script = {}
import style0 from "./DocumentDriverLicense.vue?vue&type=style&index=0&id=7b51baac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b51baac",
  null
  
)

export default component.exports